import { gql } from "@apollo/client";

export default gql`
  query GetAvailableMergeIntegrations {
    availableMergeIntegrations {
      name
      slug
      image
      squareImage
      color
      categories
    }
  }
`;
